import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import {
  API_URL_DL_MORTALITY_LOCUS_HISTORY,
  API_URL_DL_MORTALITY_ACTIVE_SITES,
  API_URL_DL_MORTALITY_DATE_FILTER,
} from 'constants/index'
import * as ApiRouter from 'constants/apiRouting'
import NoticeHelper from 'helpers/notice'
import {
  FETCH_LOCUS_HISTORY,
  SET_LOCUS_HISTORY,
  FETCH_ACTIVE_SITES,
  FETCH_ACTIVE_SITES_WITHOUT_SITE_TYPE,
  SET_ACTIVE_SITES,
  FETCH_DATE_FILTER,
  SET_DATE_FILTER,
  FETCH_ACTIVE_CAGES,
  SET_ACTIVE_CAGES,
  FETCH_MYLOG_TABLE,
  SET_MYLOG_TABLE_DATA,
  FETCH_RATE_LOG_TABLE,
  SET_RATE_LOG_TABLE_DATA,
  FETCH_WIDGET_RATE_LOG_TABLE,
  SET_WIDGET_RATE_LOG_TABLE,
  REMOVE_LOG_ROW,
  EXPORT_TO_CSV,
} from './reducer'
import { SHOW_NOTICE } from '../notice'

function* fetchActiveSites() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_DL_MORTALITY_ACTIVE_SITES, {
        site_type: 2,
      }),
    })

    yield put({
      type: SET_ACTIVE_SITES,
      list: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* fetchActiveSitesWithoutSiteType() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRouter.ACTIVE_SITES,
    })

    yield put({
      type: SET_ACTIVE_SITES,
      list: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* fetchActiveCages(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    yield put({
      type: SET_ACTIVE_CAGES,
      list: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* fetchMyLogTable(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(
        ApiRouter.DL_EVENTS_LOG,
        action.payload,
      )}${UrlHelper.getPsfsQuery(action.payload)}`,
    })
    yield put({
      type: SET_MYLOG_TABLE_DATA,
      data: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* fetchRateLogTable(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(
        ApiRouter.DL_EVENTS_LOG,
        action.payload,
      )}${UrlHelper.getPsfsQuery(action.payload)}`,
    })
    yield put({
      type: SET_RATE_LOG_TABLE_DATA,
      data: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* fetchWidgetRateLogTable(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(
        ApiRouter.DL_EVENTS_LOG,
        action.payload,
      )}${UrlHelper.getPsfsQuery(action.payload)}`,
    })
    yield put({
      type: SET_WIDGET_RATE_LOG_TABLE,
      data: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* fetchDlMortalityDateFilters(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        API_URL_DL_MORTALITY_DATE_FILTER,
        action.payload,
      ),
    })

    yield put({
      type: SET_DATE_FILTER,
      list: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* fetchDlMortalityLocusHistory(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        API_URL_DL_MORTALITY_LOCUS_HISTORY,
        action.payload,
      ),
    })

    yield put({
      type: SET_LOCUS_HISTORY,
      list: response,
    })
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* removeLogRow(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(ApiRouter.DL_REMOVE_LOG_ROW, action.payload),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Row delete successful'),
      })

      return yield call(action.promise.resolve, false)
    }
  } catch (error) {
    console.log('DL MORTALITY INTERFACE ERROR', error)
  }
}

function* exportToCsv({ payload, promise }) {
  try {
    const { data, headers } = yield call(
      fetchFromAPI,
      {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.createQuery(
          `${ApiRouter.LB_EXPORT_CSV_DATA}${UrlHelper.getPsfsQuery(payload, {
            paginationParamsEnabled: false,
          })}`,
          payload.params,
        ),
      },
      ['data', 'headers'],
    )

    if (data.hasOwnProperty('error')) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(data.message),
      })

      return yield call(promise.resolve)
    }

    if (
      !headers.hasOwnProperty('content-type') ||
      !headers.hasOwnProperty('content-disposition')
    ) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('File cannot be downloaded'),
      })

      return yield call(promise.resolve)
    }

    const type = headers['content-type'].toLowerCase().replace(' ', '')
    const [, filename] =
      headers['content-disposition'].match(/filename="([^"]+)"/i) || []

    if (!type || !filename) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('File cannot be downloaded'),
      })

      return yield call(promise.resolve)
    }

    const csvContent = new Blob([data], { type })
    const link = document.createElement('a')
    link.download = filename
    link.href = URL.createObjectURL(csvContent)
    link.click()
    URL.revokeObjectURL(link.href)

    yield call(promise.resolve)
  } catch (error) {
    console.log('EXPORT DATA FAILED ', error)
  }
}

function* digitalLogbookSaga() {
  yield takeLatest(FETCH_ACTIVE_SITES, fetchActiveSites)
  yield takeLatest(
    FETCH_ACTIVE_SITES_WITHOUT_SITE_TYPE,
    fetchActiveSitesWithoutSiteType,
  )
  yield takeLatest(FETCH_ACTIVE_CAGES, fetchActiveCages)
  yield takeLatest(FETCH_DATE_FILTER, fetchDlMortalityDateFilters)
  yield takeLatest(FETCH_LOCUS_HISTORY, fetchDlMortalityLocusHistory)
  yield takeLatest(FETCH_MYLOG_TABLE, fetchMyLogTable)
  yield takeLatest(FETCH_RATE_LOG_TABLE, fetchRateLogTable)
  yield takeLatest(FETCH_WIDGET_RATE_LOG_TABLE, fetchWidgetRateLogTable)
  yield takeLatest(REMOVE_LOG_ROW, removeLogRow)
  yield takeLatest(EXPORT_TO_CSV, exportToCsv)
}

export default digitalLogbookSaga
